export const NAV_SLICE_NAME = "nav"
